module.exports = __webpack_public_path__ + "04_short_black.9d312411.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/04_short_black.png
// module id = 4Vm0
// module chunks = 0